import React, {memo} from 'react';
import {
  StyleSheet,
  View,
} from 'react-native';

interface ITriangle {
    direction: 'up' | 'right' | 'down' | 'left' | 'up-right' | 'up-left' | 'down-right' | 'down-left',
    width?: number,
    height?: number,
    color?: string,
    style?: any
}

const Triangle = (props: ITriangle) => {
    const _borderStyles = () => {
        if (props.direction == 'up') {
          return {
            borderTopWidth: 0,
            borderRightWidth: (props.width ?? props.style.width ?? 0 )/2,
            borderBottomWidth: (props.height ?? props.style.height ?? 0),
            borderLeftWidth: (props.width ?? props.style.width ?? 0 )/2,
            borderTopColor: 'transparent',
            borderRightColor: 'transparent',
            borderBottomColor: (props.color || props.style.color),
            borderLeftColor: 'transparent',
          };
        } else if (props.direction == 'right') {
          return {
            borderTopWidth: (props.height ?? props.style.height ?? 0)/2,
            borderRightWidth: 0,
            borderBottomWidth: (props.height ?? props.style.height ?? 0)/2,
            borderLeftWidth: (props.width ?? props.style.width ?? 0 ),
            borderTopColor: 'transparent',
            borderRightColor: 'transparent',
            borderBottomColor: 'transparent',
            borderLeftColor: (props.color || props.style.color),
          };
        } else if (props.direction == 'down') {
          return {
            borderTopWidth: (props.height ?? props.style.height ?? 0),
            borderRightWidth: (props.width ?? props.style.width ?? 0 )/2,
            borderBottomWidth: 0,
            borderLeftWidth: (props.width ?? props.style.width ?? 0 )/2,
            borderTopColor: (props.color || props.style.color),
            borderRightColor: 'transparent',
            borderBottomColor: 'transparent',
            borderLeftColor: 'transparent',
          };
        } else if (props.direction == 'left') {
          return {
            borderTopWidth: (props.height ?? props.style.height ?? 0)/2,
            borderRightWidth: (props.width ?? props.style.width ?? 0 ),
            borderBottomWidth: (props.height ?? props.style.height ?? 0)/2,
            borderLeftWidth: 0,
            borderTopColor: 'transparent',
            borderRightColor: (props.color || props.style.color),
            borderBottomColor: 'transparent',
            borderLeftColor: 'transparent',
          };
        } else if (props.direction == 'up-left') {
          return {
            borderTopWidth: (props.height ?? props.style.height ?? 0),
            borderRightWidth: (props.width ?? props.style.width ?? 0 ),
            borderBottomWidth: 0,
            borderLeftWidth: 0,
            borderTopColor: (props.color || props.style.color),
            borderRightColor: 'transparent',
            borderBottomColor: 'transparent',
            borderLeftColor: 'transparent',
          };
        } else if (props.direction == 'up-right') {
          return {
            borderTopWidth: 0,
            borderRightWidth: (props.width ?? props.style.width ?? 0 ),
            borderBottomWidth: (props.height ?? props.style.height ?? 0),
            borderLeftWidth: 0,
            borderTopColor: 'transparent',
            borderRightColor: (props.color || props.style.color),
            borderBottomColor: 'transparent',
            borderLeftColor: 'transparent',
          };
        } else if (props.direction == 'down-left') {
          return {
            borderTopWidth: (props.height ?? props.style.height ?? 0),
            borderRightWidth: 0,
            borderBottomWidth: 0,
            borderLeftWidth: (props.width ?? props.style.width ?? 0 ),
            borderTopColor: 'transparent',
            borderRightColor: 'transparent',
            borderBottomColor: 'transparent',
            borderLeftColor: (props.color || props.style.color),
          };
        } else if (props.direction == 'down-right') {
          return {
            borderTopWidth: 0,
            borderRightWidth: 0,
            borderBottomWidth: (props.height ?? props.style.height ?? 0),
            borderLeftWidth: (props.width ?? props.style.width ?? 0 ),
            borderTopColor: 'transparent',
            borderRightColor: 'transparent',
            borderBottomColor: (props.color || props.style.color),
            borderLeftColor: 'transparent',
          };
        } else {
          console.error('Triangle.js wrong direction. ' + props.direction + ' is invalid. Must be one of: ' + ['up', 'right', 'down', 'left', 'up-right', 'up-left', 'down-right', 'down-left']);
          return {};
        }
      }

    return(
        <View style={[styles.triangle, _borderStyles(), props.style]}/>  
    )
}

const styles = StyleSheet.create({
   triangle: {
     width: 0,
     height: 0,
     backgroundColor: 'transparent',
     borderStyle: 'solid',
   },
 });

export default memo(Triangle);